import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import ProfileStrength from './ProfileStrength';
import ExportResume from './ExportResume';
import { useGetProfileStrengthByEmployeeQuery } from '../resumeApiSlice';
import { useParams } from 'react-router-dom';
import SkeletonExportResume from '../skeletons/SkeletonExportResume';
import SkeletonProfileStrength from '../skeletons/SkeletonProfileStrength';

const Resume = () => {
  const { empCode } = useParams();
  const { data, isLoading, error } = useGetProfileStrengthByEmployeeQuery(empCode);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
  }, [empCode]);

  useEffect(() => {
    if (data !== undefined) {
      setLoading(false);
    }
  }, [data]);

  if (isLoading || loading) {
    return (
      <Grid container sx={{ height: '89vh', position: 'relative' }}>
        <Grid item xs={12} md={12} xl={12} sx={{ position: 'sticky', height: '28vh', zIndex: 0 }}>
          <SkeletonExportResume />
        </Grid>
        <Grid item xs={12} md={12} xl={12} sx={{ overflow: 'auto', height: '61.4vh', zIndex: 1 }}>
          <SkeletonProfileStrength />
        </Grid>
      </Grid>
    );
  }
  if (error) return <p>Error loading profile strength</p>;
  const { businessUnit, strength } = data;
  return (
    <Grid container sx={{ height: '89vh', position: 'relative' }}>
      <Grid item xs={12} md={12} xl={12} sx={{ position: 'sticky', height: '28vh', zIndex: 0 }}>
        <ExportResume businessUnit={businessUnit} />
      </Grid>
      <Grid item xs={12} md={12} xl={12} sx={{ overflow: 'auto', height: '61.4vh', zIndex: 1 }}>
        <ProfileStrength profileStrengthData={strength} />
      </Grid>
    </Grid>
  );
};

export default Resume;
